// document.addEventListener('DOMContentLoaded', function() {
//   const popupWrap = document.querySelector('.promo-popup-wrap');
//   const popupTimeout = parseInt(popupWrap.getAttribute('data-popup-timeout'), 10) * 1000;
//   const popupTimes = parseInt(popupWrap.getAttribute('data-popup-times'), 10);
// 	const successMessage = popupWrap.querySelector('.promo-popup-success');
//   const closeButtons = popupWrap.querySelectorAll('.promo-popup-close');
//   const overlay = popupWrap.querySelector('.overlay');
//   const form = popupWrap.querySelector('form');

//   let popupCounter = sessionStorage.getItem('popupCounter') || 0;
//   let formSubmitted = localStorage.getItem('formSubmitted') === 'true';
//   const successMessageIsShown = localStorage.getItem('successMessageIsShown') === 'true';

// 	if (formSubmitted && successMessage && !successMessageIsShown) {
//     openPopup();
//     localStorage.setItem('successMessageIsShown', 'true');
// 	}

//   function openPopup() {
//     popupWrap.style.visibility = 'visible';
//     popupWrap.style.opacity = '1';
//     popupCounter++;
//     sessionStorage.setItem('popupCounter', popupCounter);
//   }

//   function closePopup() {
//     popupWrap.style.visibility = 'hidden';
//     popupWrap.style.opacity = '0';
//   }

//   if (!formSubmitted && popupCounter < popupTimes) {
//     setTimeout(openPopup, popupTimeout);
//   }

// 	if (closeButtons.length) {
// 		closeButtons.forEach( btn => {
// 			btn.addEventListener('click', function() {
//         closePopup();
//       });

// 			btn.addEventListener('keydown', function(event) {
// 				if (event.key === 'Enter' || event.key === ' ') {
// 					closePopup();
// 				}
// 			});
// 		})
// 	}

//   overlay.addEventListener('click', function() {
//     closePopup();
//   });

//   form.addEventListener('submit', function() {
//     localStorage.setItem('formSubmitted', 'true');
//     localStorage.setItem('successMessageIsShown', 'false');
//   });

// 	const addCopyBtn = () => {
// 		const copyBtn = document.querySelector('.promo-popup-discount__copy-btn');
// 		if (!copyBtn) {
// 			return;		
// 		}

// 		const { id } = copyBtn.dataset;
// 		if (!id) {
// 			return;
// 		}

// 		const textElement = document.getElementById(`${id}`);
// 		if (!textElement) {
// 			return;	
// 		}
		
// 		const textToCopy = textElement.innerText;
// 		let timeoutId;
		
// 		copyBtn.addEventListener('click', () => {
// 			if (navigator.clipboard && navigator.clipboard.writeText) {
// 				navigator.clipboard.writeText(textToCopy).then(function () {
// 					copyBtn.classList.add('js-copied');

// 					if (timeoutId) {
// 						clearTimeout(timeoutId);
// 					}

// 					timeoutId = setTimeout(() => {
// 						copyBtn.classList.remove('js-copied');
// 						timeoutId = null; 
// 					}, 3000);
// 				})
// 			}
// 		});
// 	}

// 	addCopyBtn();
// });

document.addEventListener('DOMContentLoaded', function() {
  const popupWrap = document.querySelector('.promo-popup-wrap');
  if (!popupWrap) return;

  const closeButtons = popupWrap.querySelectorAll('.promo-popup-close');
  const overlay = popupWrap.querySelector('.overlay');
  const form = popupWrap.querySelector('form');
  const successMessage = popupWrap.querySelector('.promo-popup-success');

  // 同一访客7天内最多显示一次
  const STORAGE_KEY = 'joaxswePromoLastShown';
  const SEVEN_DAYS = 7 * 24 * 60 * 60 * 1000;
  const lastShownTime = parseInt(
    localStorage.getItem(STORAGE_KEY) || '0',
    10
  );

  const shownWithinSevenDays =
    Date.now() - lastShownTime < SEVEN_DAYS;

  const formSubmitted =
    localStorage.getItem('formSubmitted') === 'true';

  const successMessageIsShown =
    localStorage.getItem('successMessageIsShown') === 'true';

  let popupOpened = false;
  let popupTimer = null;

  // 打开弹窗
  function openPopup(forceOpen = false) {
    if (popupOpened) return;

    if (!forceOpen && (formSubmitted || shownWithinSevenDays)) {
      return;
    }

    popupOpened = true;
    popupWrap.style.visibility = 'visible';
    popupWrap.style.opacity = '1';

    // 记录本次显示时间
    if (!forceOpen) {
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
    }

    window.removeEventListener('scroll', handleScroll);

    if (popupTimer) {
      clearTimeout(popupTimer);
    }
  }

  // 关闭弹窗
  function closePopup() {
    popupWrap.style.visibility = 'hidden';
    popupWrap.style.opacity = '0';

    if (overlay) {
      overlay.classList.add('hidden');
    }
  }

  // 已成功订阅时显示成功提示
  if (
    formSubmitted &&
    successMessage &&
    !successMessageIsShown
  ) {
    openPopup(true);
    localStorage.setItem('successMessageIsShown', 'true');
  }

  // 条件1：进入页面30秒后显示
  if (!formSubmitted && !shownWithinSevenDays) {
    popupTimer = setTimeout(function() {
      openPopup();
    }, 30000);
  }

  // 条件2：浏览到页面40%时提前显示
  function handleScroll() {
    if (popupOpened || formSubmitted || shownWithinSevenDays) {
      return;
    }

    const documentHeight =
      document.documentElement.scrollHeight - window.innerHeight;

    if (documentHeight <= 0) return;

    const scrollProgress = window.scrollY / documentHeight;

    if (scrollProgress >= 0.4) {
      openPopup();
    }
  }

  window.addEventListener('scroll', handleScroll, {
    passive: true
  });

  // 关闭按钮
  closeButtons.forEach(function(button) {
    button.addEventListener('click', closePopup);

    button.addEventListener('keydown', function(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        closePopup();
      }
    });
  });

  // 点击遮罩关闭
  if (overlay) {
    overlay.addEventListener('click', closePopup);
  }

  // 提交订阅表单
  if (form) {
    form.addEventListener('submit', function() {
      localStorage.setItem('formSubmitted', 'true');
      localStorage.setItem('successMessageIsShown', 'false');
    });
  }

  // 复制优惠码
  function addCopyBtn() {
    const copyBtn = document.querySelector(
      '.promo-popup-discount__copy-btn'
    );

    if (!copyBtn) return;

    const id = copyBtn.dataset.id;
    if (!id) return;

    const textElement = document.getElementById(id);
    if (!textElement) return;

    const textToCopy = textElement.innerText;
    let timeoutId;

    copyBtn.addEventListener('click', function() {
      if (!navigator.clipboard?.writeText) return;

      navigator.clipboard.writeText(textToCopy).then(function() {
        copyBtn.classList.add('js-copied');

        if (timeoutId) {
          clearTimeout(timeoutId);
        }

        timeoutId = setTimeout(function() {
          copyBtn.classList.remove('js-copied');
          timeoutId = null;
        }, 3000);
      });
    });
  }

  addCopyBtn();
});